import { EMPTY_CELL_VALUE } from '../../../components/NRReactGridCustomComponents/CellComponent/CellComponent';

/** Maps to GraphQL `AcrEntityType`. */
export const ACR_ENTITY_TYPE = {
  USER: 'USER',
  SECURITY_GROUP: 'SECURITY_GROUP'
};

export function buildPrincipalOptionValue(entityType, entityId) {
  return `${entityType}:${entityId}`;
}

/** Maps to GraphQL `AcrResourceType`. */
export const ACR_RESOURCE_TYPE = {
  ORGANIZATION: 'ORGANIZATION',
  ASSET_GROUP: 'ASSET_GROUP',
  ASSET: 'ASSET'
};

export const ENTITY_TYPE_LABELS = {
  [ACR_ENTITY_TYPE.USER]: 'User',
  [ACR_ENTITY_TYPE.SECURITY_GROUP]: 'Group'
};

export const RESOURCE_TYPE_LABELS = {
  [ACR_RESOURCE_TYPE.ORGANIZATION]: 'Organization',
  [ACR_RESOURCE_TYPE.ASSET_GROUP]: 'Asset Group',
  [ACR_RESOURCE_TYPE.ASSET]: 'Asset'
};

/** Select option for organization-scoped ACR resources (pinned first in resource pickers). */
export const ACR_ORGANIZATION_RESOURCE_OPTION = {
  id: ACR_RESOURCE_TYPE.ORGANIZATION,
  name: RESOURCE_TYPE_LABELS[ACR_RESOURCE_TYPE.ORGANIZATION]
};

export function formatEntityType(entityType) {
  return ENTITY_TYPE_LABELS[entityType] ?? entityType ?? EMPTY_CELL_VALUE;
}

export function formatResourceType(resourceType) {
  return RESOURCE_TYPE_LABELS[resourceType] ?? resourceType ?? EMPTY_CELL_VALUE;
}

/** Maps to org user `status` from `listOrgUsers` / RBAC `UserStatus`. */
export const ORG_USER_STATUS = {
  ENABLED: 'ENABLED',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED'
};

export const ORG_USER_ENABLED_STATUSES = [ORG_USER_STATUS.ENABLED, ORG_USER_STATUS.ACTIVE];

/** Built-in role precedence values; keep in sync with turbinepp.rbac.v1 SecurityGroupRef proto (owner=80, operator=60, member=40, readonly=20). */
export const BUILTIN_ROLE_PRECEDENCE = {
  OWNER: 80,
  OPERATOR: 60,
  MEMBER: 40,
  READONLY: 20
};

/** Keys returned by `getOrgUsersMetrics`. */
export const ORG_USERS_METRIC = {
  TOTAL: 'total',
  OWNERS: 'owners',
  DISABLED: 'disabled',
  PENDING: 'pending'
};

/** Built-in role `name` values from RBAC `listRoles`; matched case-insensitively in the UI. */
export const BUILTIN_ROLE_NAME = {
  OWNER: 'owner',
  OPERATOR: 'operator',
  MEMBER: 'member',
  READONLY: 'readonly'
};

/** Built-in role display order; matched to BE role `name` (case-insensitive). */
export const BUILTIN_ROLE_NAMES = [
  { name: BUILTIN_ROLE_NAME.OWNER, label: 'Owner' },
  { name: BUILTIN_ROLE_NAME.OPERATOR, label: 'Operator' },
  { name: BUILTIN_ROLE_NAME.MEMBER, label: 'Member' },
  { name: BUILTIN_ROLE_NAME.READONLY, label: 'Viewer' }
];
